import React from "react";

// sub category of food item
function SubCategoryCard({ subItem }) {
  return (
      <>
      {subItem.map((menu, i) => {  //map array method
        return (
          <div
            className="sub_card"
            key={i}
            style={{
              marginBottom: ".9rem",
              marginTop:"1.6rem",
              borderRadius: 5,
            }}
          >
            <img
              src={menu.thumbnails}
              alt="card-img"
              style={{ width: "260px", borderRadius: 5, height: "174px", objectFit:"cover" }}
            />
            <div className="card_body_container">
              <h3 style={{ marginTop: ".5rem" }}>{menu.title}</h3>
              <div
               className="title_menu__card_div"
              >
                <span style={{ color: "#8895A7", fontWeight:"bold" }}>{menu.description}</span>
                <div className="ratings_box">&#9733; {menu.rating}</div>
              </div>
              <h3 style={{marginBottom:"1.2rem"}}>{menu.day}</h3>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default SubCategoryCard;
